export default __webpack_public_path__ + "static/media/Illustration2.d6b0be90.png";